import { vars } from '@teamsparta/stack-tokens';
import type { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  position: 'left' | 'right';
}

export function ResizeBar({ position, style, ...props }: Props) {
  const positionStyle =
    position === 'left' ? { left: '8px' } : { right: '8px' };

  return (
    <div
      role='button'
      tabIndex={0}
      style={{
        position: 'absolute',
        bottom: '50%',
        ...positionStyle,
        transform: 'translateY(50%)',
        width: '8px',
        height: '40%',
        border: `1px solid ${vars.neutral[50]}`,
        backgroundColor: 'white',
        opacity: 0.3,
        borderRadius: '4px',
        cursor: 'col-resize',
        zIndex: 1,
        ...style,
      }}
      {...props}
    />
  );
}
